import { d as r } from "./descriptors.js";
import { f as t } from "./fails.js";
var o = r && t(function () {
  return 42 != Object.defineProperty(function () {}, "prototype", {
    value: 42,
    writable: !1
  }).prototype;
});
export { o as v };